export const style = {
  card: {
    cardHeader: {
      typography: {
        variant: 'h6',
        color: 'primary.text',
      },
    },
    sx: {
      mt: 5,
    },
    style: {
      position: 'relative',
    },
  },
  cardDisabled: {
    backgroundColor: '#F3F4F6',
    pointerEvents: 'none',
  },
} as const;
